module.exports = __webpack_public_path__ + "img/file-01.eecc0524.svg";